import { render } from "./ResourceTableToolbar.vue?vue&type=template&id=97e6f26a"
import script from "./ResourceTableToolbar.vue?vue&type=script&lang=js"
export * from "./ResourceTableToolbar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ResourceTableToolbar.vue"]])

export default __exports__